import src from "IMAGE";
export default { src, width: 1440, height: 400, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQ0lEQVR42g3HUQqAIBBAQQ8ShWma7tpGgUX3v9fLr2Gc2Mn7XHxdUSmEuNH2FUszhxkupkgZaWkih2H2dPXcdUGk8gMFlxfASbcb5gAAAABJRU5ErkJggg=="};
